import styled from "styled-components"
import Menu from "./Menu"

const TopMenu = styled.div`
  opacity: ${props => (props.$isOpen ? "1" : "0")};
  visibility: ${props => (props.$isOpen ? "visible" : "hidden")};
  transition: ${props => props.theme.transition.long};
  position: absolute;
  margin-top: 60px;

  ${Menu}::before {
    content: "";
    position: absolute;
    top: 0;
    right: 12px;
    left: auto;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 10px 10px 10px;
    border-top-color: transparent;
    border-right-color: transparent;
    border-left-color: transparent;
    border-bottom-color: ${props => props.theme.color.semiTranslucid};
  }
`

export default TopMenu
